// Recovered compiled webpack factory 49567. Edit this function expression; run npm run build.
(e, t, n) => {
  "use strict";
  (n.r(t), n.d(t, { default: () => d }));
  var r = n(95155),
    o = n(12115),
    i = n(27122),
    a = n(80486);
  function s(e) {
    let t = e.message || "";
    return (
      "ChunkLoadError" === e.name ||
      t.includes("Loading chunk") ||
      t.includes("__webpack_modules__") ||
      t.includes("Failed to fetch dynamically imported module")
    );
  }
  function d(e) {
    let { error: t, reset: n } = e,
      d = t.digest === a.fY || (0, a.$W)(t);
    return (
      (0, o.useEffect)(() => {
        if (s(t)) {
          let e = "chunk-reload";
          if (!sessionStorage.getItem(e)) {
            (sessionStorage.setItem(e, "1"), window.location.reload());
            return;
          }
          sessionStorage.removeItem(e);
        }
        i.Cp(t);
      }, [t]),
      (0, r.jsxs)("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100dvh",
          fontFamily: "var(--font-geist), system-ui, sans-serif",
          gap: "1rem",
          padding: "2rem",
          textAlign: "center",
        },
        children: [
          (0, r.jsx)("h2", {
            style: { fontSize: "1.25rem", fontWeight: 600 },
            children: d ? "Database is not responding" : "Something went wrong",
          }),
          (0, r.jsx)("p", {
            style: { color: "#666", maxWidth: "24rem" },
            children: d
              ? "Mockup Studio could not load this page. Your local work is unchanged. Try reloading."
              : s(t)
                ? "The studio was updated. Reloading to get the latest..."
                : "An unexpected error occurred. Please try again.",
          }),
          (0, r.jsx)("button", {
            onClick: () => {
              (sessionStorage.removeItem("chunk-reload"), n());
            },
            style: {
              padding: "0.5rem 1.5rem",
              borderRadius: "0.5rem",
              border: "1px solid #ccc",
              background: "#fff",
              cursor: "pointer",
              fontSize: "0.875rem",
            },
            children: "Try again",
          }),
        ],
      })
    );
  }
}
